<template>
    <el-tooltip
        placement="top"
        popper-class="desensitization-eye-tooltip-popper"
        :disabled="!isOverflow"
        :content="infoText">
        <template v-slot:content>
            <div class="content-box">{{ infoText }}</div>
        </template>
        <div ref="box" class="tooltip-info">{{ infoText }}</div>
    </el-tooltip>
</template>

<script>
export default {
    name: 'TooltipInfo',
    props: {
        content: {
            type: [String, Number, Boolean],
            default: ''
        }
    },
    data() {
        return {
            isOverflow: false
        };
    },

    computed: {
        infoText() {
            const content = [null, undefined].includes(this.content) ? '' : this.content;
            return String(content);
        }
    },

    mounted() {
        this.checkOverflow();
        // 订阅$el尺寸变化，重新检查是否溢出
        this.$nextTick(() => {
            if (this.$refs.box) {
                this.resizeObserver = new ResizeObserver(this.checkOverflow);
                this.resizeObserver.observe(this.$refs.box);
            }
        });
    },
    updated() {
        this.$nextTick(this.checkOverflow);
    },
    beforeDestroy() {
        // 取消订阅
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    },
    methods: {
        // 检查是否溢出，溢出才显示tooltip，否则不显示
        checkOverflow() {
            const el = this.$refs.box;
            if (!el || !this.infoText) {
                this.isOverflow = false;
                return;
            }
            this.isOverflow = el.scrollWidth > el.offsetWidth;
        }
    }
};
</script>

<style lang="less" scoped>
.tooltip-info {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.content-box {
    padding: 10px;
    max-width: 640px;
    max-height: 120px;
    overflow: auto;
    line-height: 1.5;
}
</style>

<style lang="less">
.desensitization-eye-tooltip-popper {
    padding: 0px;
}
</style>
